// Minimal session/token holder for the API client to attach existing auth
// headers. This foundation packet does not implement login  -  it only
// preserves a place for the login packet's auth flow to write a token into,
// and for the API client to read from, without ever persisting it in
// runtime config. The token itself never carries role/scope decisions on
// the frontend; the backend is always the source of truth for authorization.

const SESSION_STORAGE_KEY = "workmatex.session.token";

export function getSessionToken() {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setSessionToken(token) {
  try {
    if (token) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
  } catch {
    // Storage unavailable (e.g. privacy mode)  -  session simply won't persist.
  }
}

export function clearSessionToken() {
  setSessionToken(null);
}

export function isAuthenticated() {
  return Boolean(getSessionToken());
}
